import { render, staticRenderFns } from "./slotly.vue?vue&type=template&id=198edfb4&lang=pug&"
import script from "./slotly.vue?vue&type=script&lang=js&"
export * from "./slotly.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('198edfb4', component.options)
    } else {
      api.reload('198edfb4', component.options)
    }
    module.hot.accept("./slotly.vue?vue&type=template&id=198edfb4&lang=pug&", function () {
      api.rerender('198edfb4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/layertree/component/node/slotly.vue"
export default component.exports